<template>
  <a
    v-if="canUseFeature(ConversationsFeatureConfigurationSlug) && hasAccessToSchedule"
    :href="redirectLink"
    aria-label="Conversations"
    class="conversations-button"
  >
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1813 13.4286C11.0685 13.4286 11.799 14.2321 11.799 15.1429C11.799 16.1071 11.0685 16.8571 10.1813 16.8571C9.24197 16.8571 8.51137 16.1071 8.51137 15.1429C8.51137 14.2321 9.24197 13.4286 10.1813 13.4286ZM16.0261 13.4286C16.9132 13.4286 17.6438 14.2321 17.6438 15.1429C17.6438 16 16.861 16.8036 16.0261 16.8036C15.1389 16.8036 14.3561 16.0536 14.3561 15.1429C14.3561 14.1786 15.0867 13.4286 16.0261 13.4286ZM21.8708 13.4286C22.7579 13.4286 23.5407 14.2321 23.4885 15.1429C23.4885 16.1071 22.7579 16.8571 21.8708 16.8571C20.9837 16.8571 20.2009 16.1071 20.2009 15.1429C20.2009 14.2321 20.9315 13.4286 21.8708 13.4286ZM16.0261 4C23.3842 4 29.3333 9.08929 29.3333 15.1964C29.3333 21.3036 23.3842 26.2857 16.0261 26.2857C14.3039 26.2857 12.634 26.0179 11.1728 25.5357C9.60727 26.6607 7.10237 28 3.91907 28C3.39722 28 2.92755 27.7321 2.771 27.1964C2.61444 26.7143 2.66663 26.1786 3.03192 25.8036C3.03192 25.8036 4.64967 23.9821 5.43244 21.8929C3.71033 20.0179 2.66663 17.6607 2.66663 15.1429C2.66663 8.98214 8.61575 4 16.0261 4ZM16.0261 23.7143C21.9752 23.7143 26.7762 19.9107 26.7762 15.1429C26.7762 10.4286 21.923 6.57143 15.9739 6.57143C10.0247 6.57143 5.17152 10.4286 5.17152 15.1429C5.17152 17.4464 6.26741 19.1607 7.20674 20.1786L8.30263 21.3571L7.7286 22.8571C7.46767 23.6071 7.10237 24.3571 6.68489 25C7.93734 24.5714 8.98104 23.9821 9.71164 23.4464L10.7032 22.6964L11.9034 23.0714C13.208 23.5 14.6171 23.7143 16.0261 23.7143Z"
        fill="white"
      />
    </svg>
  </a>
</template>

<script>
import { mapGetters } from 'vuex';
import { ConversationsFeatureConfigurationSlug } from '@/constants';

const { LIVE_INSTRUCTION_APP_URL } = process.env;

export default {
  name: 'ConversationsButton',

  data() {
    return {
      ConversationsFeatureConfigurationSlug,
    };
  },

  computed: {
    ...mapGetters('features', ['canUseFeature', 'hasAccessToSchedule']),
    ...mapGetters(['userProfile', 'token']),

    redirectLink() {
      let url = `${LIVE_INSTRUCTION_APP_URL}/chat`;

      url += `?userId=${this.userProfile.id}&token=${this.token}`;

      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
.conversations-button {
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
}
</style>
